import { useCallback, useEffect, useState } from 'react'
import { api } from './api'
import type { LogNameKind } from './types'

/**
 * Names already used on this farm's logs for one kind (buildings, facilities, equipment, pest
 * devices), as suggestions. `buildingName` narrows pest devices to one building.
 */
export function useLogNames(orgId: string | undefined, farmId: string | undefined, kind: LogNameKind | undefined, buildingName?: string) {
  const [names, setNames] = useState<string[]>([])

  const reload = useCallback(async () => {
    if (!orgId || !farmId || !kind) return
    const query = new URLSearchParams({ kind })
    if (buildingName) query.set('buildingName', buildingName)
    try {
      setNames(await api.get<string[]>(`/orgs/${orgId}/farms/${farmId}/farm-log-names?${query}`))
    } catch {
      setNames([]) // suggestions only; typing still works
    }
  }, [orgId, farmId, kind, buildingName])

  useEffect(() => {
    reload()
  }, [reload])

  return { names, reload }
}
